// extracted by mini-css-extract-plugin
export var langSwitcherList = "LangSwitchersList-module--langSwitcherList--3h+p-";